<template>
  <v-card flat color="transparent" class="d-flex justify-center align-center">
    <slot> </slot>
  </v-card>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
